<template>
    <v-container fluid class="fill-height">
    <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
        <v-row no-gutters>
            <v-col>
                <!-- 第一行 -->
                <v-row no-gutters>
                    <v-col v-5="permissionCode.problem"  cols="12" md="6" class="px-12">
                        <v-card>
                            <v-card-title>
                                实时异常考勤情况
                                <el-select @change="pageChange" class="ml-12" v-model="attendanceClassId" filterable
                                           placeholder="请选择">
                                    <el-option
                                        v-for="item in attendanceClassItems"
                                        :key="item.value"
                                        :label="item.text"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </v-card-title>
                            <v-data-table color="grey darken-3"
                                          :items-per-page="5"
                                          :headers="headers"
                                          :items="desserts"
                                          single-select
                                          class="elevation-1"
                                          :loading="loading"
                                          :footer-props="footerProps"
                                          :loading-text="loadingText"
                                          :options.sync="options"
                                          :server-items-length="totalDesserts"
                                          @update:options="changeOptions"
                            >
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" class="px-12" >
                        <v-card>
                            <v-row class="ml-1">
                                <v-card-title>
                                    当前跟踪学生情况
                                </v-card-title>
                                <v-card-actions>
                                    <v-col cols="8" md="8" sm="3" xs="3">
                                        <el-select @change="initEchartsLineData" v-model="studentId" filterable
                                                   placeholder="请选择">
                                            <el-option
                                                v-for="item in studentItems"
                                                :key="item.value"
                                                :label="item.text"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </v-col>
                                    <v-col cols="4" md="4" sm="3" xs="3">
                                        <v-btn color="primary mr-3" @click="showDetailDialog" dark large>
                                            <v-icon left>mdi-account-details</v-icon>
                                            详情
                                        </v-btn>
                                    </v-col>
                                </v-card-actions>
                            </v-row>

                            <v-row>
                                <v-col style="height: 320px">
                                    <et-charts ref="etchartsRef" :option="studentOptions"></et-charts>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-5="permissionCode.score">
            <v-col>
                <v-row no-gutters>
                    <v-col cols="12" md="12" class="px-12">
                        <v-card>
                            <v-row class="ml-1">
                                <v-card-title>
                                    考试总览
                                </v-card-title>
                                <v-card-actions>
                                    <v-col cols="8" md="8" sm="3" xs="3">
                                        <el-select @change="initExamEcharts" v-model="classId" filterable
                                                   placeholder="请选择">
                                            <el-option
                                                v-for="item in classItems"
                                                :key="item.value"
                                                :label="item.text"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </v-col>
                                </v-card-actions>
                            </v-row>
                            <v-row>
                                <v-col style="height: 400px">
                                    <et-charts ref="classEchartsRef" :option="classOptions"></et-charts>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-dialog v-model="showDetail" max-width="1000px">
            <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
        </v-dialog>
    </v-responsive>
    </v-container>
</template>

<script>
    import Mock from 'mockjs';
    import 'echarts/map/js/china'
    import echarts from 'echarts'
    import scoreDetail from '../score/score-detail'

    export default {
        data() {
            return {
                stuDetailMsg:{},
                showDetail:false,
                permissionCode:{
                    problem:'biz:home:attendance:problem',
                    score:'biz:home:score',
                },
                searchData: {
                    classId: ''
                },
                totalDesserts: 0,
                desserts: [],
                loading: false,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions:[5,10,20,50],
                    //disableItemsPerPage:true,
                },
                options: {},
                classId: '',
                studentId: "",
                studentItems: [],
                classItems: [],
                attendanceClassItems: [{text: '全部', value: ''}],
                attendanceClassId: '',
                headers: [{
                    text: '姓名',
                    value: 'studentName',
                },
                    {
                        text: '班级',
                        value: 'className'
                    },
                    {
                        text: '描述',
                        value: 'attendanceResultDesc'
                    },
                    {
                        text: '时间',
                        value: 'attendanceTime'
                    }
                ],
                tableData: [],
                lineXData: [],
                lineYData: [],
                classLineXData: [],
                legendData: [],
                legendSelectData: {},
                seriesData: [],
                weekFlag: false,
                monthFlag: false,
                colorList: ['#FFCCCC','#CCFF99','#CCCCCC','#99CCCC','#C33531', '#EFE42A', '#64BD3D', '#EE9201', '#29AAE3', '#B74AE5', '#0AAF9F', '#E89589', '#16A085', '#4A235A', '#C39BD3', '#F9E79F', '#BA4A00', '#643FEE', '#616A6B', '#BD974B', '#4A235A', '#3498DB','#20FFDF','#13EF9D'],
            }
        },
        mounted() {
            this.initClassItems()
            this.initAttentionStudent()
        },
        computed: {
            classOptions() {
                return {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: this.legendData,
                        selected: this.legendSelectData,
                        height: '88%',
                        right: '20',
                        top: '0',
                        itemGap: 25,
                        itemWidth: 13,
                        itemHeight: 13,
                        textStyle: {
                            fontSize: '13',
                            color: '#666',
                        },
                    },
                    grid: {
                        left: '5%',
                        right: '4%',
                        bottom: '5%',
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: true,
                        start: 0,
                        end: 50,
                        handleSize: 8
                    },
                        {
                            type: 'inside',
                            start: 0,
                            end: 50
                        }
                    ],
                    xAxis: [
                        {
                            type: 'category',
                            data: this.classLineXData,
                            axisPointer: {
                                type: 'shadow'
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '成绩',
                            // min: 0,
                            // max: 2500,
                        }
                    ],
                    series: this.seriesData
                }
            },
            studentOptions() {
                return {
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: [{
                        type: 'category',
                        data: this.lineXData,
                        axisLine: {
                            lineStyle: {
                                color: "#999"
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#000000'
                            }
                        }
                    }],
                    yAxis: [{
                        type: 'value',
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#DDD'
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#333"
                            },
                        },
                        nameTextStyle: {
                            color: "#999"
                        },
                        splitArea: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#000000'
                            }
                        }
                    }],
                    series: [{
                        name: '分数',
                        type: 'line',
                        data: this.lineYData,
                        markPoint: {
                            // symbolSize: 80,控制气泡大小
                            itemStyle:{
                                normal:{
                                    label:{
                                        show: true,
                                        color: '#f7f5f5',//气泡中字体颜色
                                    }
                                }
                            },
                            data: [
                                {type: 'max', name: '最大值',itemStyle:{color: '#48D8BF'}},
                                {type: 'min', name: '最小值',itemStyle:{color: '#48D8BF'}}
                            ]
                        },
                        markLine: {
                            itemStyle: {
                                normal: { lineStyle: { type: 'solid', color: '#09d0e6' }},
                            },
                            data: [
                                {type: 'average', name: '平均值'}
                            ],
                        },
                        lineStyle: {
                            normal: {
                                width: 8,
                                color: {
                                    type: 'linear',

                                    colorStops: [{
                                        offset: 0,
                                        color: '#A9F387' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: '#48D8BF' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 10,
                                shadowOffsetY: 20
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#fff',
                                borderWidth: 10,
                                /*shadowColor: 'rgba(72,216,191, 0.3)',
                                shadowBlur: 100,*/
                                borderColor: "#A9F387"
                            }
                        },
                        smooth: true
                    }]
                }
            }
        },
        methods: {
            showDetailDialog(){
                if(this.studentId === null || this.studentId === ''){
                    this.$message({
                        message:"请选择学生",
                        type: 'warning',
                        duration:2000
                    });
                    return
                }
                this.showDetail = true
                this.stuDetailMsg.studentId = this.studentId
            },
            initExamEcharts() {
                if (this.classId == "" || this.classId == null) {
                    return
                }
                this.classLineXData = []
                this.legendData = []
                this.legendSelectData = {}
                this.seriesData = []
                this.weekFlag = false
                this.monthFlag = false
                this.$api.achievement.barChat({classId: this.classId}).then(data => {
                    if (data.data) {
                        data.data.forEach((obj, index) => {
                            //加载x轴数据
                            this.classLineXData.push(obj.stuName)
                            if (index == 0) {
                                //加载图列
                                obj.exams.forEach((objCh, index) => {
                                    let data = []
                                    let legendName = objCh.name
                                    this.legendData.push(legendName)
                                    if (this.weekFlag && !objCh.type) {
                                        this.legendSelectData[legendName] = false
                                    }
                                    if (this.monthFlag && objCh.type) {
                                        this.legendSelectData[legendName] = false
                                    }
                                    //周考
                                    if (!objCh.type) {
                                        this.weekFlag = true
                                    } else {
                                        this.monthFlag = true
                                    }
                                    data.push(objCh.score)
                                    let currOptions = {
                                        name: legendName,
                                        type: 'bar',
                                        color: this.colorList[index],
                                        data: data
                                    }
                                    this.seriesData.push(currOptions)
                                })
                            } else {
                                //加载
                                obj.exams.forEach((objCh, index) => {
                                    this.seriesData[index].data.push(objCh.score)
                                })
                            }

                        })

                    }
                    this.$refs.classEchartsRef.setOption();
                })
            },
            initAttentionStudent() {
                this.$api.student.getAttentionStudent().then(data => {
                    if (data.data) {
                        data.data.forEach((obj, index) => {
                            this.studentItems.push({text: obj.name, value: obj.id})
                            if (index == 0) {
                                this.studentId = obj.id
                                this.initEchartsLineData()
                            }
                        })

                    }
                })
            },
            initClassItems() {
                this.$api.classList.getLatelyClass().then(data => {
                    if (data.data) {
                        data.data.forEach((obj, index) => {

                            this.classItems.push({text: obj.className, value: obj.id})
                            this.attendanceClassItems.push({text: obj.className, value: obj.id})
                            if (data.data.length-1 == index + 1) {
                                this.classId = obj.id
                                this.initExamEcharts()
                            }
                        })
                    }
                })
            },
            initEchartsLineData() {
                if (this.studentId == "" || this.studentId == null) {
                    return
                }
                this.lineXData = []
                this.lineYData = []
                this.$api.achievement.studentLine({stuId: this.studentId, examType: ["0", "1"]}).then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.lineXData.push(obj.examName)
                            this.lineYData.push(obj.score)
                        })
                        this.$refs.etchartsRef.setOption();
                    }
                })
            },
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            initialize() {
                this.loading = true
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.attendance.getAttendance(
                    Object.assign({}, {classId: this.attendanceClassId}, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                // let data = Mock.mock({
                //   "data|6-14": [{
                //     "name": '@name()',
                //     "calories|100-300": 159,
                //     "fat": '@float(60, 100, 1, 2)',
                //     "carbs|10-30": 24,
                //     "protein": '@float(60, 100, 1, 2)',
                //     iron: '@integer(60, 100)' + '%',
                //   }]
                // })
            },
            changeOptions(option) {
                this.initialize()
            }
        },
        components:{
            scoreDetail
        }
    }
</script>
<style scoped="scoped">
    a {
        text-decoration: none;
    }

    .row-line {
        border-bottom: 1px solid #303030;
    }

    .message-list-menu {
        list-style: outside none none;
        margin: 0;
        padding: 0;
    }

    ul.message-list-menu li {
        padding: 5px 0px;
        font-size: 14px;
    }

    ul.message-list-menu li {
        padding: 5px 0px;
        font-size: 14px;
        border-bottom: 1px solid #303030;
    }

    ul.message-list-menu li:last-child {
        padding-bottom: 0px;
        border-bottom: 0px solid #ddd;
    }

    ul.message-list-menu li .message-time {
        text-align: right;
    }

    ul.message-list-menu li .message-info {
        width: 62%;;
        display: inline-block;
    }

    ul.message-list-menu li .message-serial {
        width: 25px;
        display: inline-block;
        text-align: center;
        margin-right: 10px;
        background: #303030;
        color: #fff;
        border-radius: 4px;
        padding: 2px 0px;
    }

    ul.message-list-menu li .message-serial.message-cl-one {
        background: #03a9f0;
    }

    ul.message-list-menu li .message-serial.message-cl-two {
        background: #303030;
    }

    ul.message-list-menu li .message-serial.message-cl-three {
        background: #1ab394;
    }

    ul.message-list-menu li .message-serial.message-cl-four {
        background: #ccc;
        color: #303030;
    }

    ul.message-list-menu li .message-serial.message-cl-five {
        background: #1c84c6;
    }
</style>
